import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { DistrictSwitcher } from '../../features/_shell/DistrictSwitcher'
import './TopBarActions.css'

interface TopBarActionsProps {
  feedbackUrl?: string
  helpUrl: string
  supportHref: string
  isSuperAdmin: boolean
}

export function TopBarActions({
  feedbackUrl,
  helpUrl,
  supportHref,
  isSuperAdmin,
}: TopBarActionsProps) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  return (
    <div className="vp-topbar-actions">
      <DistrictSwitcher />
      {isSuperAdmin && (
        <button
          type="button"
          className="vp-topbar-actions__btn"
          onClick={() => navigate({ to: supportHref })}
        >
          {t('topbar.support')}
        </button>
      )}
      {feedbackUrl && (
        <a
          className="vp-topbar-actions__link"
          href={feedbackUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('topbar.feedback')}
        </a>
      )}
      <a
        className="vp-topbar-actions__link"
        href={helpUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('topbar.help')}
      </a>
    </div>
  )
}
